import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    margin: '15px',
  },
  button: {
    width: '100%',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#F97F11',
    '&:hover': {
      backgroundColor: '#F97F11',
    },
  },
}));

export default useStyles;
